import React, { useContext } from "react";
import { useParams } from 'react-router-dom';
import PageContainer from "@components/pages/PageContainer";
import HeaderCredits from "@components/composite/HeaderCredits/HeaderCredits";
import SubmissionCreate from '@components/submissions/SubmissionCreate';
import SubmissionsList from '@components/submissions/SubmissionsList';
import SubmissionsDetails from '@components/submissions/SubmissionsDetails';
import { CreditsContext } from "@stores/CreditsContext";
import { MenuContext } from '@stores/MenuContext';
import { ActionMapT, getTitle, getComponent } from '@pages/Pages.utils';

const debug = false;

const actionsMap:ActionMapT = {
  'create': {
    title: 'New Submission',
    component: <SubmissionCreate />
  },
  'details': {
    title: 'Submission Details',
    component: <SubmissionsDetails />
  },
  'default': {
    title: 'My Prior Submissions',
    component: <SubmissionsList />
  }
}

const PgSubmissions = () => {
  let { action } = useParams(); // this is the action that sets what to do
  let submissionHash = '';
  if (action && action.includes('-')) {
    submissionHash = action;
    action = 'details';
  }
  debug && console.log("PgSubmissions | action: ", action, " submissionHash:", submissionHash)
  const { creditsInfo } = useContext(CreditsContext);
  debug && console.log("PgSubmissions | creditsInfo:", creditsInfo);
  const { activeMenuId, setActiveMenuId } = useContext(MenuContext);
  if (action === 'create') {
    if (activeMenuId !== 'newSubmission') setActiveMenuId('newSubmission');
  } else {
    if (activeMenuId !== 'mySubmissions') setActiveMenuId('mySubmissions');
  }


  return (
    <PageContainer title={getTitle(actionsMap, action)}  >
      { !action || ['default'].includes(action) ? <HeaderCredits /> : null }
      { action !== 'details' ?
        getComponent(actionsMap, action)
        :
        <SubmissionsDetails hash={submissionHash}/>
      }
    </PageContainer>
  );
};

export default PgSubmissions;
